module.exports = __webpack_public_path__ + "img/ic_video_stop.b43bf023.png";